import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import {
    SegmentCardEvent,
    segmentTrackAction
} from '../../../../../../../../../middlewares/segment';
import {
    ESegmentClickType,
    ESegmentClickTypeEventOption
} from '../../../../../../../../../middlewares/segment/constants';

export const onDoubleClickEvent = (
): ThunkAction => {
    return (
        dispatch: Dispatch
    ) => {
        dispatch(segmentTrackAction(SegmentCardEvent.CARD_PREVIEW_RENAME_CLICKED, {
            name: ESegmentClickTypeEventOption.CLICK_TYPE,
            value: ESegmentClickType.double
        }));
    };
};
